import { CommonModule } from '@angular/common';
import { Component, Input, NgModule } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-modal',
  imports: [CommonModule],
  template: `
  <div class="popup">
    <div class="modal-body" style="max-width: 820px;">
      <h2 id="page-title">
        <span>
          <span id="lblHeader">{{ title }}</span>
        </span>
      </h2>
     
      <div id="pnlDocument" style="min-width: 690px;">
        <div class="row">
            <div id="info" class="col col-md-8">
                <span id="lblDescription">{{ message }}</span>
            </div>
            <div class="col col-md-4">
                <span id="lblImage"><img style="max-width: 250px;" [src]="thumbnailUrl" [attr.alt]="title ? title + ' document preview image' : 'Document preview image'" (error)="onImageError($event)"></span>
            </div>
        </div>
        <div class="row">
            <div class="col col-md-12 buttons">
              <span id="linkButton"><a [href]="downloadUrl" class="dl" [attr.aria-label]="title ? 'Download ' + title : 'Download document'" target="_blank" rel="noopener noreferrer">Download document</a></span>
            </div>
        </div>
      </div>
      <ng-container *ngIf="imageList.length > 0">
        <div *ngFor="let row of imageList; let rowIndex = index" class="row">
          <div *ngFor="let item of row; let colIndex = index" class="image col col-md-4">
            <div style="min-height: 150px;">
              <img [src]="item" width="165" [attr.alt]="(title ? title + ' gallery image ' : 'Gallery image ') + (rowIndex * 3 + colIndex + 1)" (error)="onImageError($event)">
            </div>
          </div>
        </div>
      </ng-container>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="activeModal.dismiss()">Close</button>
  </div>
  `
})
export class PreviewProductModalComponent {
  @Input() title = '';
  @Input() message = '';
  @Input() downloadUrl= '';
  @Input() thumbnailUrl = ''
  @Input() imageList = [] as string[][];
  readonly imageFallbackSrc = 'assets/images/fallback-logo.svg';

  constructor(public activeModal: NgbActiveModal) { }

  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement | null;
    if (!target) {
      return;
    }

    const fallbackSrc = this.imageFallbackSrc;
    const currentSrc = String(target.getAttribute('src') || target.src || '');
    if (currentSrc.includes(fallbackSrc)) {
      return;
    }

    target.src = fallbackSrc;
  }
}
